module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    style: ('min-height: ' + _vm.alturaContentWrapper + 'px')
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Edição de Instituição Parceira'
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm._.isNull(_vm.id) ? 'Novo Parceiro' : (_vm.ehVisualizacao ? 'Visualiza' : 'Edição de') + ' Parceiro Estratégico '))]), _vm._v(" "), (!_vm.ehVisualizacao) ? _c('span', [(_vm._.isNull(_vm.id)) ? _c('span', [(_vm.salvaParceiro.statusSalvamento !== 'PROCESSANDO') ? _c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    attrs: {
      "color": "primary",
      "type": "button",
      "title": '<h5>Ao clicar ele criará este parceiro no sistema para uso. Então antes de fazê-lo verifique se não existe este parceiro ou semelhante já criado</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cria novo parceiro")]) : _vm._e(), _vm._v(" "), (_vm.salvaParceiro.statusSalvamento === 'PROCESSANDO') ? _c('span', {
    staticClass: "button--moema warning",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 50px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-borda-dark) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Criando Parceiro ...")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.id)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando)),
      expression: "_.isEmpty(editando)"
    }]
  }, [(_vm.salvaParceiro.statusSalvamento === 'PROCESSANDO') ? _c('span', {
    staticClass: "button--moema warning",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 50px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-borda-dark) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Salvando")]) : (_vm.salvaParceiro.statusSalvamento === 'FEITO') ? _c('span', {
    staticClass: "button--moema success",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 10px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-verde) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Cadastro salvo")]) : _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'lista-articulacoes'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "content",
    attrs: {
      "id": "parceiro"
    }
  }, [_c('div', {
    staticClass: "row nao_imprimir"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('acao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome do parceiro")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parceiro.nome),
      expression: "parceiro.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "nome_parceiro",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome_parceiro",
      "disabled": _vm.ehVisualizacao || !_vm._.isEmpty(_vm.editando),
      "title": '<h5>Nome do parceiro, preferencialmente completo tal como no CNPJ</h5>'
    },
    domProps: {
      "value": (_vm.parceiro.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.parceiro, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome_parceiro')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O nome da instituição parceira é obrigatório")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando)),
      expression: "_.isEmpty(editando)"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    class: {
      'has-error': _vm.errors.first('parceiro_cnpj')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cnpj'),
      expression: "'cnpj'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    class: {
      'has-error': _vm.errors.first('parceiro_cnpj')
    },
    attrs: {
      "name": "parceiro_cnpj",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens,
      "disabled": _vm.ehVisualizacao,
      "type": "text",
      "title": '<h5>CNPJ da intituição estratégica para parcerias</h5>'
    },
    model: {
      value: (_vm.parceiro.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.parceiro, "cnpj", $$v)
      },
      expression: "parceiro.cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('parceiro_cnpj')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('parceiro_cnpj')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('sede')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-1"
  }, [_vm._v("Sede")]), _vm._v(" "), (_vm.loading.abrangencia) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "col-lg-3"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaAbrangencias[3].lista,
      "disabled": _vm.ehVisualizacao,
      "multiple": false,
      "placeholder": "Selecione a sede",
      "label": "descricao",
      "track-by": "codigo",
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "sede"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(props.option.descricao)
          }
        })]
      }
    }]),
    model: {
      value: (_vm.parceiro.sede),
      callback: function($$v) {
        _vm.$set(_vm.parceiro, "sede", $$v)
      },
      expression: "parceiro.sede"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('sede')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve ser informada a sede da organização")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "indicadores-cb-inline"
  }, [_c('label', {
    staticClass: "control-label col-md-3"
  }, [_vm._v("Cliente Dicor?\n                    "), (!_vm.ehVisualizacao) ? _c('div', [_c('i', {
    class: !_vm.parceiro.dicor ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado',
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.parceiro.dicor = !_vm.parceiro.dicor
      }
    }
  })]) : _c('div', {
    staticClass: "text-muted selecionado"
  }, [_vm._v("\n                      " + _vm._s(_vm.parceiro.dicor ? 'Sim' : 'Não') + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando)),
      expression: "_.isEmpty(editando)"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('abrangencia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Abrangência")]), _vm._v(" "), (_vm.loading.abrangencia) ? _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaAbrangencias,
      "disabled": _vm.ehVisualizacao,
      "multiple": true,
      "placeholder": "Selecione a abrangência",
      "label": "descricao",
      "group-values": "lista",
      "group-label": "grupo",
      "track-by": "codigo",
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "abrangencia"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(_vm._.has(props.option, '$groupLabel')) ? _c('div', {
          staticClass: "text-bold",
          domProps: {
            "innerHTML": _vm._s(props.option.$groupLabel)
          }
        }) : _c('div', {
          staticStyle: {
            "margin-left": "1em"
          },
          domProps: {
            "innerHTML": _vm._s(props.option.descricao)
          }
        })]
      }
    }]),
    model: {
      value: (_vm.parceiro.abrangencias),
      callback: function($$v) {
        _vm.$set(_vm.parceiro, "abrangencias", $$v)
      },
      expression: "parceiro.abrangencias"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('abrangencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" A abrangência da parceria é obrigatória")]) : _vm._e()], 1)])]), _vm._v(" "), (false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando)),
      expression: "_.isEmpty(editando)"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Valores")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', {}, [_c('tr', {}, [_c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "valorFBB",
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.parceiro.orcamento.fbb),
      callback: function($$v) {
        _vm.$set(_vm.parceiro.orcamento, "fbb", $$v)
      },
      expression: "parceiro.orcamento.fbb"
    }
  })], 1), _vm._v(" "), _c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "valorFBB",
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.parceiro.orcamento.parceiro),
      callback: function($$v) {
        _vm.$set(_vm.parceiro.orcamento, "parceiro", $$v)
      },
      expression: "parceiro.orcamento.parceiro"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-bold text-center"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.parceiro.orcamento.fbb) + _vm._.toNumber(_vm.parceiro.orcamento.parceiro))) + "\n                      ")])])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.id)) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando) || _vm._.has(_vm.editando, 'contato')),
      expression: "_.isEmpty(editando) || _.has(editando, 'contato')"
    }],
    staticClass: "box-body"
  }, [_vm._m(3), _vm._v(" "), (_vm._.isEmpty(_vm.editando) || (!_vm._.isEmpty(_vm.editando) && !_vm._.has(_vm.editando, 'contato'))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Contato")]), _vm._v(" "), _c('th', [_vm._v("Cargo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "140px",
      "text-align": "center"
    }
  }, [_vm._v("Telefone(s)")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', {
    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.edita(_vm.editando, 'contato', _vm._.cloneDeep(_vm.contato), -1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.parceiro.contatos.length === 0) ? _c('tbody', {}, [_vm._m(4)]) : _c('tbody', {}, _vm._l((_vm.parceiro.contatos), function(contato, idxContato) {
    return _c('tr', {}, [_c('td', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(contato.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contato.cargo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("telefone")(contato.telefone)) + "\n                            "), (!_vm._.isNull(contato.telefone)) ? _c('span', [_c('br'), _vm._v(_vm._s(_vm._f("telefone")(contato.telefone2)))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contato.email))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "max-width": "200px"
      }
    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'contato', contato, idxContato)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplica(_vm.parceiro.contatos, idxContato)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(_vm.parceiro.contatos, idxContato)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "success",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'contato', contato, idxContato)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Visualizar")])], 1)])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'contato')) ? _c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('nome_contato')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.contato.nome),
      expression: "editando.contato.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "nome_contato",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome_contato",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Nome do contato na instituição parceira</h5>'
    },
    domProps: {
      "value": (_vm.editando.contato.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editando.contato, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome_contato')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O nome do contato é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Cargo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.contato.cargo),
      expression: "editando.contato.cargo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "cargo_contato",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cargo_contato",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Cargo dele na instituição ou o equivalente ao cargo. Em geral (Presidente, Diretor, Coordenador de projeto, Contato, etc) </h5>'
    },
    domProps: {
      "value": (_vm.editando.contato.cargo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editando.contato, "cargo", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.contato.email),
      expression: "editando.contato.email"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email|min:1|max:255'),
      expression: "'email|min:1|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "type": "text",
      "title": '<h5>Diite um e-mail pessoal ou corporativo para o contato, se tiver</h5>',
      "name": "email_contato"
    },
    domProps: {
      "value": (_vm.editando.contato.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editando.contato, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('the-mask', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "type": "text",
      "placeholder": "(00) 00000-0000",
      "title": '<h5>Informe um telefone ou celular para entrar em contato com esta pessoa</h5>',
      "disabled": _vm.ehVisualizacao,
      "name": "telefone_contato"
    },
    model: {
      value: (_vm.editando.contato.telefone),
      callback: function($$v) {
        _vm.$set(_vm.editando.contato, "telefone", $$v)
      },
      expression: "editando.contato.telefone"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("2º Telefone")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('the-mask', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "mask": ['(##) ####-####', '(##) #####-####'],
      "type": "text",
      "placeholder": "(00) 00000-0000",
      "title": '<h5>Informe um outro telefone ou celular para contato caso haja</h5>',
      "disabled": _vm.ehVisualizacao,
      "name": "telefone_contato_2"
    },
    model: {
      value: (_vm.editando.contato.telefone2),
      callback: function($$v) {
        _vm.$set(_vm.editando.contato, "telefone2", $$v)
      },
      expression: "editando.contato.telefone2"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('nome_contato') || _vm.errors.first('telefone_contato')))) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ok(_vm.editando, 'contato', _vm.parceiro.contatos)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.cancela(_vm.editando, 'contato')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando) || _vm._.has(_vm.editando, 'historico')),
      expression: "_.isEmpty(editando) || _.has(editando, 'historico')"
    }],
    staticClass: "box-body"
  }, [_vm._m(5), _vm._v(" "), (_vm._.isEmpty(_vm.editando) || (!_vm._.isEmpty(_vm.editando) && !_vm._.has(_vm.editando, 'historico'))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Informação")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "120px"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.edita(_vm.editando, 'historico', _vm._.cloneDeep(_vm.historico), -1);
        _vm.editando.historico.data = new Date()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.parceiro.historicos.length === 0) ? _c('tbody', {}, [_vm._m(6)]) : _c('tbody', {}, _vm._l((_vm.parceiro.historicos), function(historico, idxHistorico) {
    return _c('tr', {}, [_c('td', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(_vm._.get(_vm._.find(_vm.listaTipos, ['codigo', historico.tipo]), 'descricao')))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(historico.conteudo)
      }
    })]), _vm._v(" "), _c('td', [(_vm._.has(historico, 'usuario.ds_nome_usuario')) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
      }],
      staticClass: "truncar",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "title": '<h5>' + historico.usuario.ds_nome_usuario + ' (id: ' + historico.usuario.id + ')</h5>'
      }
    }, [_vm._v("\n                              " + _vm._s(historico.usuario.ds_nome_usuario) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                            " + _vm._s(_vm._f("moment")(historico.data, "L")) + "\n                            "), (!_vm._.isNull(historico.prazo)) ? _c('span', [_c('p', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm._f("moment")(historico.prazo, "L")))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "max-width": "200px"
      }
    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'historico', historico, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplica(_vm.parceiro.historicos, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(_vm.parceiro.historicos, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "success",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'historico', historico, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Visualizar")])], 1)])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'historico')) ? _c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('tipo_historico')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.historico.tipo),
      expression: "editando.historico.tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "tipo_historico",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "tipo_historico",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>O tipo do histórico permite definir ações de cobrança, lembrete, auditagem etc</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editando.historico, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listaTipos), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.codigo
      }
    }, [_vm._v(_vm._s(tipo.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('tipo_historico')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O tipo do histórico é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-1"
  }, [_vm._v("Data")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "data_historico",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehVisualizacao,
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.historico.data),
      callback: function($$v) {
        _vm.$set(_vm.editando.historico, "data", $$v)
      },
      expression: "editando.historico.data"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-1"
  }, [_vm._v("Prazo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "prazo_historico",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehVisualizacao,
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "disabled-dates": {
        to: new Date(_vm.editando.historico.data)
      },
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.historico.prazo),
      callback: function($$v) {
        _vm.$set(_vm.editando.historico, "prazo", $$v)
      },
      expression: "editando.historico.prazo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('conteudo_historico')
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('quill-editor', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "conteudo_historico",
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "options": _vm.quillOptionsCompleto,
      "title": '<h5>Descreva o que foi feito ou que será feito, seja um contato, reunião, assinatura de instrumento etc</h5>',
      "name": "conteudo_historico"
    },
    model: {
      value: (_vm.editando.historico.conteudo),
      callback: function($$v) {
        _vm.$set(_vm.editando.historico, "conteudo", $$v)
      },
      expression: "editando.historico.conteudo"
    }
  }), _vm._v(" "), (_vm.errors.first('tipo_historico')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Registre algum conteúdo para histórico")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('conteudo_historico') || _vm.errors.first('tipo_historico')))) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dadosUsuarioHistorico(_vm.editando.historico);
        _vm.ok(_vm.editando, 'historico', _vm.parceiro.historicos)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.cancela(_vm.editando, 'historico')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando)),
      expression: "_.isEmpty(editando)"
    }],
    staticClass: "box-body"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(8), _vm._v(" "), (_vm.loading.dependenciasBB) ? _c('tbody', [_vm._m(9)]) : _c('tbody', [_c('tr', [_c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.listaDependenciasBB,
      "disabled": _vm.ehVisualizacao,
      "multiple": false,
      "placeholder": "Selecione a dependência",
      "label": "nome",
      "track-by": "prefixo",
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "dependenciaBB"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_vm._v(_vm._s(props.option.prefixo) + " - " + _vm._s(props.option.nome))]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.prefixo))]), _vm._v(" " + _vm._s(props.option.nome))]
      }
    }], null, false, 3779099504),
    model: {
      value: (_vm.parceiro.bb),
      callback: function($$v) {
        _vm.$set(_vm.parceiro, "bb", $$v)
      },
      expression: "parceiro.bb"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parceiro.bb.contato),
      expression: "parceiro.bb.contato"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "bbContato",
    staticClass: "form-control",
    attrs: {
      "name": "bbContato",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Nome do gerente ou do contato na dependência</h5>'
    },
    domProps: {
      "value": (_vm.parceiro.bb.contato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.parceiro.bb, "contato", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parceiro.bb.telefone),
      expression: "parceiro.bb.telefone"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "bbTelefone",
    staticClass: "form-control",
    attrs: {
      "name": "bbTelefone",
      "disabled": _vm.ehVisualizacao,
      "type": "tel",
      "title": '<h5>Telefone do contato ou número principal da dependência</h5>'
    },
    domProps: {
      "value": (_vm.parceiro.bb.telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.parceiro.bb, "telefone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parceiro.bb.email),
      expression: "parceiro.bb.email"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "bbContato",
    staticClass: "form-control",
    attrs: {
      "name": "bbContato",
      "disabled": _vm.ehVisualizacao,
      "type": "email",
      "title": '<h5>E-mail do contato na dependência</h5>'
    },
    domProps: {
      "value": (_vm.parceiro.bb.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.parceiro.bb, "email", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.isEmpty(_vm.editando) || _vm._.has(_vm.editando, 'parceria')),
      expression: "_.isEmpty(editando) || _.has(editando, 'parceria')"
    }],
    staticClass: "box-body"
  }, [_vm._m(10), _vm._v(" "), (_vm._.isEmpty(_vm.editando) || (!_vm._.isEmpty(_vm.editando) && !_vm._.has(_vm.editando, 'parceria'))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v("Valores")]), _vm._v(" "), _c('th', {
    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.edita(_vm.editando, 'parceria', _vm._.cloneDeep(_vm.parceria), -1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.parceiro.parcerias.length === 0) ? _c('tbody', [_vm._m(11)]) : _c('tbody', _vm._l((_vm.parceiro.parcerias), function(parceria, idxParceria) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(parceria.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._.get(_vm._.find(_vm.situacoesParceria, ['codigo', parceria.situacao]), 'descricao')))]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', [_vm._v("Parceria")]), _c('td', [_vm._v(_vm._s(_vm._f("real")(parceria.orcamento.fbb)))]), _c('td', [_vm._v(_vm._s(_vm._f("real")(parceria.orcamento.parceiro)))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(parceria.projetos.length + ' projeto' + (parceria.projetos.length > 1 ? 's' : '')))]), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(parceria.projetos, 'orcamento.fbb'))))]), _c('td', [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(parceria.projetos, 'orcamento.parceiro'))))])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "max-width": "225px"
      }
    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'parceria', parceria, idxParceria)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplica(_vm.parceiro.parcerias, idxParceria)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(_vm.parceiro.parcerias, idxParceria)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "success",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'parceria', parceria, idxParceria)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Visualizar")])], 1)])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), (_vm._.has(_vm.editando, 'parceria')) ? _c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('nome_parceria')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome da parceria")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.parceria.nome),
      expression: "editando.parceria.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "nome_parceria",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome_parceria",
      "disabled": _vm.ehVisualizacao || (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length > 1),
      "title": '<h5>Nome da parceria, preferencialmente o nome que constará em instrumentos futuros</h5>'
    },
    domProps: {
      "value": (_vm.editando.parceria.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editando.parceria, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome_parceria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O nome da parceria é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Situação")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.parceria.situacao),
      expression: "editando.parceria.situacao"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "parceria_situacao",
      "disabled": _vm.ehVisualizacao || (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length > 1),
      "title": '<h5>Situação em que se encontra a parceria atualmente</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editando.parceria, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.situacoesParceria), function(situacao) {
    return _c('option', {
      domProps: {
        "value": situacao.codigo
      }
    }, [_vm._v(_vm._s(situacao.descricao))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length === 1),
      expression: "_.has(editando, 'parceria') && _.keys(editando).length === 1"
    }],
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Abrangência")]), _vm._v(" "), (_vm.loading.abrangencia) ? _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(12)]) : _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    ref: 'ABRANGENCIA-PARCERIA-' + _vm.numeroAtualizacao,
    attrs: {
      "options": _vm.listaAbrangencias,
      "disabled": _vm.ehVisualizacao,
      "multiple": true,
      "placeholder": "Selecione a abrangência",
      "label": "descricao",
      "group-values": "lista",
      "group-label": "grupo",
      "track-by": "codigo",
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "abrangencia_parceria"
    },
    on: {
      "select": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(_vm._.has(props.option, '$groupLabel')) ? _c('div', {
          staticClass: "text-bold",
          domProps: {
            "innerHTML": _vm._s(props.option.$groupLabel)
          }
        }) : _c('div', {
          staticStyle: {
            "margin-left": "1em"
          },
          domProps: {
            "innerHTML": _vm._s(props.option.descricao)
          }
        })]
      }
    }], null, false, 3485813107),
    model: {
      value: (_vm.editando.parceria.abrangencias),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceria, "abrangencias", $$v)
      },
      expression: "editando.parceria.abrangencias"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length === 1),
      expression: "_.has(editando, 'parceria') && _.keys(editando).length === 1"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Valores")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', {}, [_c('tr', {}, [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('money', {
    staticClass: "form-control text-center",
    attrs: {
      "name": "valorFBB",
      "disabled": _vm.ehVisualizacao
    },
    nativeOn: {
      "blur": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.parceria.orcamento.fbb),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceria.orcamento, "fbb", $$v)
      },
      expression: "editando.parceria.orcamento.fbb"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('money', {
    staticClass: "form-control text-center",
    attrs: {
      "name": "valorFBB",
      "disabled": _vm.ehVisualizacao
    },
    nativeOn: {
      "blur": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.parceria.orcamento.parceiro),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceria.orcamento, "parceiro", $$v)
      },
      expression: "editando.parceria.orcamento.parceiro"
    }
  })], 1), _vm._v(" "), _c('td', {
    ref: 'TOTAL-PARCERIA-' + _vm.numeroAtualizacao,
    staticClass: "text-bold text-center"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.editando.parceria.orcamento.fbb) + _vm._.toNumber(_vm.editando.parceria.orcamento.parceiro))) + "\n                          ")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm._.keys(_vm.editando).length === 1 && _vm._.has(_vm.editando, 'parceria')) || (_vm._.keys(_vm.editando).length > 1 && _vm._.has(_vm.editando, 'parceriaInstrumento'))),
      expression: "(_.keys(editando).length === 1 && _.has(editando, 'parceria')) || (_.keys(editando).length > 1 && _.has(editando, 'parceriaInstrumento'))"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(14), _vm._v(" "), (!_vm._.has(_vm.editando, 'parceriaInstrumento')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "100px"
    }
  }, [_vm._v("Assinatura")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "100px"
    }
  }, [_vm._v("Vigência")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "150px"
    }
  }, [_vm._v("Valores")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "100px"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "100px"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.edita(_vm.editando, 'parceriaInstrumento', _vm._.cloneDeep(_vm.instrumento), -1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), ((_vm._.get(_vm.editando, 'parceria.instrumentos', [])).length === 0) ? _c('tbody', {}, [_vm._m(15)]) : _c('tbody', {}, _vm._l((_vm._.get(_vm.editando, 'parceria.instrumentos', [])), function(instrumento, idxInstrumento) {
    return _c('tr', {}, [_c('td', [_vm._v("\n                                " + _vm._s(instrumento.nome.descricao) + "\n                              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(instrumento.dataAssinatura, "L")) + "\n                              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(instrumento.dataVigencia, "L")) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                FBB: " + _vm._s(_vm._f("real")(instrumento.orcamento.fbb))), _c('br'), _vm._v("\n                                Parc.: " + _vm._s(_vm._f("real")(instrumento.orcamento.parceiro)) + "\n                              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(instrumento.orcamento.fbb + instrumento.orcamento.parceiro)) + "\n                              ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      class: (_vm.situacaoInstrumento(instrumento)).classe
    }, [_vm._v(_vm._s((_vm.situacaoInstrumento(instrumento)).texto))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'parceriaInstrumento', instrumento, idxInstrumento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplica(_vm.editando.parceria.instrumentos, idxInstrumento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(_vm.editando.parceria.instrumentos, idxInstrumento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "success",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'parceriaInstrumento', instrumento, idxInstrumento)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Visualizar")])], 1)])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 extratoff"
  }, [_c('table', {
    staticClass: "totais"
  }, [_vm._m(16), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._.get(_vm.editando, 'parceria.instrumentos', []).length))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.instrumentos', []), function(p) {
    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0))
  }))))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.instrumentos', []), function(p) {
    return _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
  }))))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.instrumentos', []), function(p) {
    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0)) + _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
  }))))])])])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaInstrumento')) ? _c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('nome_instrumento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Instrumento")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: 'INSTRUMENTO-PARCERIA-' + _vm.numeroAtualizacao,
    attrs: {
      "options": _vm.listaInstrumentos,
      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo'),
      "multiple": false,
      "placeholder": "Selecione",
      "label": "descricao",
      "track-by": "codigo",
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "instrumento_parceria"
    },
    on: {
      "select": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_vm._v("\n                                  " + _vm._s(props.option.descricao) + "\n                                ")]
      }
    }], null, false, 4289602459),
    model: {
      value: (_vm.editando.parceriaInstrumento.nome),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaInstrumento, "nome", $$v)
      },
      expression: "editando.parceriaInstrumento.nome"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2), _vm._v(" "), (_vm.errors.first('nome_instrumento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O instrumento é obrigatório")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data da Assinatura")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "instrumento_data_assinatura",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo'),
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.parceriaInstrumento.dataAssinatura),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaInstrumento, "dataAssinatura", $$v)
      },
      expression: "editando.parceriaInstrumento.dataAssinatura"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data da Vigência")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "instrumento_data_vigencia",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo'),
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy",
      "disabled-dates": {
        to: new Date(_vm.editando.parceriaInstrumento.dataAssinatura)
      }
    },
    on: {
      "input": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.parceriaInstrumento.dataVigencia),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaInstrumento, "dataVigencia", $$v)
      },
      expression: "editando.parceriaInstrumento.dataVigencia"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
    ref: 'SITUACAO-PARCERIA-' + _vm.numeroAtualizacao,
    staticClass: "control-label col-md-2"
  }, [_c('span', {
    class: (_vm.situacaoInstrumento(_vm.editando.parceriaInstrumento)).classe
  }, [_vm._v(_vm._s((_vm.situacaoInstrumento(_vm.editando.parceriaInstrumento)).texto))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Valores")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(17), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaInstrumento.orcamento.fbb')) ? _c('tbody', {}, [_c('tr', {}, [_c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "valorFBB",
      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo')
    },
    model: {
      value: (_vm.editando.parceriaInstrumento.orcamento.fbb),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaInstrumento.orcamento, "fbb", $$v)
      },
      expression: "editando.parceriaInstrumento.orcamento.fbb"
    }
  })], 1), _vm._v(" "), _c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "valorParceiro",
      "disabled": _vm.ehVisualizacao || _vm._.has(_vm.editando, 'parceriaInstrumentoAnexo')
    },
    model: {
      value: (_vm.editando.parceriaInstrumento.orcamento.parceiro),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaInstrumento.orcamento, "parceiro", $$v)
      },
      expression: "editando.parceriaInstrumento.orcamento.parceiro"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-bold text-center"
  }, [_vm._v("\n                                  " + _vm._s(_vm._f("real")(_vm._.toNumber(_vm.editando.parceriaInstrumento.orcamento.fbb) + _vm._.toNumber(_vm.editando.parceriaInstrumento.orcamento.parceiro))) + "\n                                ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-online', {
    attrs: {
      "idProcesso": _vm.idCriacao,
      "propDocumentos": _vm.editando.parceriaInstrumento.anexos,
      "documentTypes": '',
      "ehVisualizacao": _vm.ehVisualizacao,
      "secaoOrigem": 'PARCERIA_INSTRUMENTO',
      "local-uso": 'TODOS'
    },
    on: {
      "arquivoAnexado": function($event) {
        return _vm.editando.parceriaInstrumento.anexos.push($event)
      },
      "arquivoExcluido": function($event) {
        return _vm._.remove(_vm.editando.parceriaInstrumento.anexos, ['id', $event.id])
      },
      "layoutAtual": function($event) {
        $event === 'LISTA' ? _vm.cancela(_vm.editando, 'parceriaInstrumentoAnexo') : _vm.edita(_vm.editando, 'parceriaInstrumentoAnexo', _vm._.cloneDeep(_vm.anexo), -1)
      },
      "acaoSalvar": _vm.salvarEdicao,
      "acaoOk": function($event) {
        _vm.ok(_vm.editando, 'parceriaInstrumento', _vm.editando.parceria.instrumentos, false);
        _vm.ok(_vm.editando, 'parceria', _vm.parceiro.parcerias, false)
      },
      "acaoCancelar": function($event) {
        return _vm.cancela(_vm.editando, 'parceriaInstrumentoAnexo')
      },
      "acaoProcessamento": function($event) {
        _vm.loading.tela = true
      },
      "acaoAguardando": function($event) {
        _vm.loading.tela = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm._.has(_vm.editando, 'parceriaInstrumentoAnexo')),
      expression: "!_.has(editando, 'parceriaInstrumentoAnexo')"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ok(_vm.editando, 'parceriaInstrumento', _vm.editando.parceria.instrumentos)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.cancela(_vm.editando, 'parceriaInstrumento')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm._.keys(_vm.editando).length === 1 && _vm._.has(_vm.editando, 'parceria')) || (_vm._.keys(_vm.editando).length > 1 && _vm._.has(_vm.editando, 'parceriaProjeto'))),
      expression: "(_.keys(editando).length === 1 && _.has(editando, 'parceria')) || (_.keys(editando).length > 1 && _.has(editando, 'parceriaProjeto'))"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(18), _vm._v(" "), (!_vm._.has(_vm.editando, 'parceriaProjeto')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Projeto")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Valores")]), _vm._v(" "), _c('th', {
    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.edita(_vm.editando, 'parceriaProjeto', _vm._.cloneDeep(_vm.projeto), -1);
        _vm.projetoSelecionado = null
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), ((_vm._.get(_vm.editando, 'parceria.projetos', [])).length === 0) ? _c('tbody', {}, [_vm._m(19)]) : _c('tbody', {}, _vm._l((_vm._.get(_vm.editando, 'parceria.projetos', [])), function(projetoSocial, idxProjeto) {
    return _c('tr', {}, [_c('td', [(!_vm._.isEmpty(projetoSocial.numero)) ? _c('span', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(projetoSocial.numero) + " - ")]) : _vm._e(), _vm._v(_vm._s(projetoSocial.nome) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm._.get(_vm._.find(_vm.situacoesProjeto, ['codigo', projetoSocial.situacao]), 'descricao')) + "\n                              ")]), _vm._v(" "), _c('td', [_vm._v("\n                                " + _vm._s(_vm._f("real")(projetoSocial.orcamento.fbb + projetoSocial.orcamento.parceiro))), _c('br'), _vm._v("\n                                " + _vm._s(_vm._f("real")(projetoSocial.execucao.fbb + projetoSocial.execucao.parceiro)) + "\n                              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "max-width": "200px"
      }
    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          _vm.edita(_vm.editando, 'parceriaProjeto', projetoSocial, idxProjeto);
          _vm.projetoSelecionado = _vm._.find(_vm.listaProjetosSociais, ['numero', projetoSocial.numero])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplica(_vm.editando.parceria.projetos, idxProjeto)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(_vm.editando.parceria.projetos, idxProjeto)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "success",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          _vm.edita(_vm.editando, 'parceriaProjeto', _vm.projeto, idxProjeto);
          _vm.projetoSelecionado = _vm._.find(_vm.listaProjetosSociais, ['numero', projetoSocial.numero])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Visualizar")])], 1)])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 extratoff"
  }, [_c('table', {
    staticClass: "totais"
  }, [_vm._m(20), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._.get(_vm.editando, 'parceria.projetos', []).length))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.projetos', []), function(p) {
    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0))
  }))))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.projetos', []), function(p) {
    return _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
  }))))]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.get(_vm.editando, 'parceria.projetos', []), function(p) {
    return _vm._.toNumber(_vm._.get(p, 'orcamento.fbb', 0)) + _vm._.toNumber(_vm._.get(p, 'orcamento.parceiro', 0))
  }))))])])])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaProjeto')) ? _c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Número")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    attrs: {
      "id": "numero_projeto_parceria"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaProjetosSociais,
      "disabled": _vm.ehVisualizacao,
      "multiple": false,
      "placeholder": "Selecione",
      "label": "numero",
      "track-by": "numero",
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "numero_projeto_parceria"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(props.option.situacao))]), _vm._v("  " + _vm._s(props.option.numero) + " - " + _vm._s(props.option.nome))])]
      }
    }], null, false, 3607906466),
    model: {
      value: (_vm.projetoSelecionado),
      callback: function($$v) {
        _vm.projetoSelecionado = $$v
      },
      expression: "projetoSelecionado"
    }
  }, [_vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum registro localizado!")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('nome_projeto_parceria')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.parceriaProjeto.nome),
      expression: "editando.parceriaProjeto.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "nome_projeto_parceria",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome_projeto_parceria",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero),
      "title": '<h5>Nome do projeto. Se já existir, ao informar o número o SGP trará o nome e outras informações. Se não existir o projeto, use este campo para dar um nome qualquer ao projeto até sua criação</h5>'
    },
    domProps: {
      "value": (_vm.editando.parceriaProjeto.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editando.parceriaProjeto, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome_projeto_parceria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O nome para o projeto é obrigatório seja ele existente ou sugestão para nome quando for criado")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Situação")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.parceriaProjeto.situacao),
      expression: "editando.parceriaProjeto.situacao"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao_projeto_parceria",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero),
      "title": '<h5>Situação em que se encontra o parceiro</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editando.parceriaProjeto, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.situacoesProjeto), function(situacao) {
    return _c('option', {
      domProps: {
        "value": situacao.codigo
      }
    }, [_vm._v(_vm._s(situacao.descricao))])
  }), 0)]), _vm._v(" "), (!_vm._.isEmpty(_vm.projetoSelecionado)) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "font-weight": "bold",
      "border": "0",
      "background": "none"
    }
  }, [_vm._v(_vm._s(_vm.projetoSelecionado.situacao))])]) : _vm._e()]), _vm._v(" "), (_vm.loading.investimentoProjeto) ? _c('div', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando dados do projeto " + _vm._s(_vm.editando.parceriaProjeto.numero) + "...")]) : (_vm._.has(_vm.projetoSelecionado, 'cadastro')) ? _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-1"
  }, [_vm._v("Assinatura")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0",
      "background": "none"
    }
  }, [(_vm._.get(_vm.projetoSelecionado, 'cadastro.usu_datcon', '1900').indexOf('1900') === -1) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.projetoSelecionado.cadastro.usu_datcon, "L")))]) : _c('span', [_vm._v("sem data")])])]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-md-1"
  }, [_vm._v("Término")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0",
      "background": "none"
    }
  }, [(_vm._.get(_vm.projetoSelecionado, 'cadastro.datfpj', '1900').indexOf('1900') === -1) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.projetoSelecionado.cadastro.datfpj, "L")))]) : _c('span', [_vm._v("sem data")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', {}, [_c('tr', [_c('th', {
    staticClass: "col-md-3"
  }, [(_vm.loading.investimentoProjeto) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando valores do " + _vm._s(_vm.editando.parceriaProjeto.numero) + "...")]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "col-md-3"
  }, [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-3"
  }, [_vm._v("Parceiro")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-3"
  }, [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', [_c('tr', {}, [_c('td', {
    staticClass: "text-bold"
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "orcadoFBB",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
    },
    model: {
      value: (_vm.editando.parceriaProjeto.orcamento.fbb),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.orcamento, "fbb", $$v)
      },
      expression: "editando.parceriaProjeto.orcamento.fbb"
    }
  })], 1), _vm._v(" "), _c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "orcadoParceiro",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
    },
    model: {
      value: (_vm.editando.parceriaProjeto.orcamento.parceiro),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.orcamento, "parceiro", $$v)
      },
      expression: "editando.parceriaProjeto.orcamento.parceiro"
    }
  })], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")((_vm.editando.parceriaProjeto.orcamento.fbb + _vm.editando.parceriaProjeto.orcamento.parceiro))))])])]), _vm._v(" "), _c('tr', {}, [_c('td', {
    staticClass: "text-bold"
  }, [_vm._v("Executado")]), _vm._v(" "), _c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "executadoFBB",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
    },
    model: {
      value: (_vm.editando.parceriaProjeto.execucao.fbb),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.execucao, "fbb", $$v)
      },
      expression: "editando.parceriaProjeto.execucao.fbb"
    }
  })], 1), _vm._v(" "), _c('td', [_c('money', {
    staticClass: "form-control",
    attrs: {
      "name": "executadoParceiro",
      "disabled": _vm.ehVisualizacao || !_vm._.isNull(_vm.editando.parceriaProjeto.numero)
    },
    model: {
      value: (_vm.editando.parceriaProjeto.execucao.parceiro),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.execucao, "parceiro", $$v)
      },
      expression: "editando.parceriaProjeto.execucao.parceiro"
    }
  })], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")((_vm.editando.parceriaProjeto.execucao.fbb + _vm.editando.parceriaProjeto.execucao.parceiro))))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Municípios - Locais de execução\n                              "), (_vm.loading.investimentoProjeto) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando dados de municípios ...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "600px",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "margin-bottom": "1rem"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "per-page": 5,
      "bordered": true,
      "current-page": _vm.tabelaMunicipios.currentPage,
      "items": _vm.editando.parceriaProjeto.municipios,
      "fields": _vm.tabelaMunicipios.fields,
      "empty-text": "Nenhum recurso/município cadastrado"
    },
    scopedSlots: _vm._u([{
      key: "fase",
      fn: function(row) {
        return [_vm._v("\n                                    " + _vm._s(('' + row.value).substr(0, 1) === '1' ? 'Fundação BB' : ('' + row.value).substr(0, 1) === '5' ? 'Parceiro' : 'Contrapartida') + "\n                                  ")]
      }
    }, {
      key: "cidade",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value) + " / " + _vm._s(row.item.uf))]
      }
    }, {
      key: "valor",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("real")(row.value)))]
      }
    }], null, false, 115768954)
  }), _vm._v(" "), (_vm.editando.parceriaProjeto.municipios.length > 5) ? _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.editando.parceriaProjeto.municipios.length,
      "per-page": 5
    },
    model: {
      value: (_vm.tabelaMunicipios.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tabelaMunicipios, "currentPage", $$v)
      },
      expression: "tabelaMunicipios.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'ACAO']),
      "disabled": _vm.ehVisualizacao,
      "placeholder": "Ação Estratégica",
      "label": "descricao",
      "track-by": "codigo",
      "name": "acao_estrategica_projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return undefined
      }
    }], null, false, 4207429160),
    model: {
      value: (_vm.editando.parceriaProjeto.enquadramento.acaoEstrategica),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "acaoEstrategica", $$v)
      },
      expression: "editando.parceriaProjeto.enquadramento.acaoEstrategica"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'TIPO_ACAO']),
      "disabled": _vm.ehVisualizacao,
      "placeholder": "Tipo da Ação",
      "label": "descricao",
      "track-by": "codigo",
      "name": "tipo_acao_projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return undefined
      }
    }], null, false, 4207429160),
    model: {
      value: (_vm.editando.parceriaProjeto.enquadramento.tipoAcao),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "tipoAcao", $$v)
      },
      expression: "editando.parceriaProjeto.enquadramento.tipoAcao"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'PROGRAMA']),
      "disabled": _vm.ehVisualizacao,
      "placeholder": "Programa Estruturado",
      "label": "descricao",
      "track-by": "codigo",
      "name": "programa_estruturado_projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return undefined
      }
    }], null, false, 4207429160),
    model: {
      value: (_vm.editando.parceriaProjeto.enquadramento.programaEstruturado),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "programaEstruturado", $$v)
      },
      expression: "editando.parceriaProjeto.enquadramento.programaEstruturado"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'ACAO']),
      "disabled": _vm.ehVisualizacao,
      "placeholder": "Projeto Superior",
      "label": "descricao",
      "track-by": "codigo",
      "name": "projeto_superior_projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return undefined
      }
    }], null, false, 4207429160),
    model: {
      value: (_vm.editando.parceriaProjeto.enquadramento.projetoSuperior),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "projetoSuperior", $$v)
      },
      expression: "editando.parceriaProjeto.enquadramento.projetoSuperior"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'CADEIAS_PRODUTIVAS']),
      "disabled": _vm.ehVisualizacao,
      "placeholder": "Cadeia Produtiva",
      "label": "descricao",
      "track-by": "codigo",
      "name": "cadeia_produtiva_projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return undefined
      }
    }], null, false, 4207429160),
    model: {
      value: (_vm.editando.parceriaProjeto.enquadramento.cadeiaProdutiva),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "cadeiaProdutiva", $$v)
      },
      expression: "editando.parceriaProjeto.enquadramento.cadeiaProdutiva"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm._.filter(_vm.listaCategorizadoresEnquadramento, ['grupo', 'AREA_ESTRATEGICA']),
      "disabled": _vm.ehVisualizacao,
      "placeholder": "Eixo de Atuacao",
      "label": "descricao",
      "track-by": "codigo",
      "name": "eixo_atuacao_projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return undefined
      }
    }], null, false, 4207429160),
    model: {
      value: (_vm.editando.parceriaProjeto.enquadramento.eixoAtuacao),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaProjeto.enquadramento, "eixoAtuacao", $$v)
      },
      expression: "editando.parceriaProjeto.enquadramento.eixoAtuacao"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('conteudo_historico') || _vm.errors.first('tipo_historico')))) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ok(_vm.editando, 'parceriaProjeto', _vm.editando.parceria.projetos)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.cancela(_vm.editando, 'parceriaProjeto')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm._.keys(_vm.editando).length === 1 && _vm._.has(_vm.editando, 'parceria')) || (_vm._.keys(_vm.editando).length > 1 && _vm._.has(_vm.editando, 'parceriaHistorico'))),
      expression: "(_.keys(editando).length === 1 && _.has(editando, 'parceria')) || (_.keys(editando).length > 1 && _.has(editando, 'parceriaHistorico'))"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(22), _vm._v(" "), (!_vm._.has(_vm.editando, 'parceriaHistorico')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Informação")]), _vm._v(" "), _c('th', [_vm._v("Usuário")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "120px"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    style: ('text-align: center;width: ' + (_vm.ehVisualizacao ? 120 : 260) + 'px;')
  }, [(!_vm.ehVisualizacao) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        _vm.edita(_vm.editando, 'parceriaHistorico', _vm._.cloneDeep(_vm.historico), -1);
        _vm.editando.parceriaHistorico.data = new Date()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]) : _vm._e()], 1)])]), _vm._v(" "), ((_vm._.get(_vm.editando, 'parceria.historicos', [])).length === 0) ? _c('tbody', {}, [_vm._m(23)]) : _c('tbody', {}, _vm._l((_vm._.get(_vm.editando, 'parceria.historicos', [])), function(historico, idxHistorico) {
    return _c('tr', {}, [_c('td', {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(_vm._.get(_vm._.find(_vm.listaTipos, ['codigo', historico.tipo]), 'descricao')))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(historico.conteudo)
      }
    })]), _vm._v(" "), _c('td', [(_vm._.has(historico, 'usuario.ds_nome_usuario')) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
      }],
      staticClass: "truncar",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "title": '<h5>' + historico.usuario.ds_nome_usuario + ' (id: ' + historico.usuario.id + ')</h5>'
      }
    }, [_vm._v("\n                                  " + _vm._s(historico.usuario.ds_nome_usuario) + "\n                                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("moment")(historico.data, "L")) + "\n                                "), (!_vm._.isNull(historico.prazo)) ? _c('span', [_c('p', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm._f("moment")(historico.prazo, "L")))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "max-width": "200px"
      }
    }, [(!_vm.ehVisualizacao) ? _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'parceriaHistorico', historico, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "warning",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.duplica(_vm.editando.parceria.historicos, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Duplicar")]), _vm._v(" "), _c('g-button-ujarak', {
      attrs: {
        "color": "error",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.remove(_vm.editando.parceria.historicos, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _c('span', [_c('g-button-ujarak', {
      attrs: {
        "color": "success",
        "size": "button--size-ss"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.edita(_vm.editando, 'parceriaHistorico', historico, idxHistorico)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Visualizar")])], 1)])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.editando, 'parceriaHistorico')) ? _c('div', {
    staticClass: "col-md-12 well"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('tipo_historico_parceria')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editando.parceriaHistorico.tipo),
      expression: "editando.parceriaHistorico.tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "tipo_historico_parceria",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "tipo_historico_parceria",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>O tipo do histórico permite definir ações de cobrança, lembrete, auditagem etc</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editando.parceriaHistorico, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listaTipos), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.codigo
      }
    }, [_vm._v(_vm._s(tipo.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('tipo_historico_parceria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" O tipo do histórico dessa parceria é obrigatório")]) : _vm._e()])]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-1"
  }, [_vm._v("Data")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "data_historico_parceria",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehVisualizacao,
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.parceriaHistorico.data),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaHistorico, "data", $$v)
      },
      expression: "editando.parceriaHistorico.data"
    }
  })], 1)]), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "control-label col-md-1"
  }, [_vm._v("Prazo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "prazo_historico_parceria",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehVisualizacao,
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "disabled-dates": {
        to: new Date(_vm.editando.parceriaHistorico.data)
      },
      "format": "dd/MM/yyyy"
    },
    on: {
      "input": function($event) {
        _vm.numeroAtualizacao++
      }
    },
    model: {
      value: (_vm.editando.parceriaHistorico.prazo),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaHistorico, "prazo", $$v)
      },
      expression: "editando.parceriaHistorico.prazo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('conteudo_historico_parceria')
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('quill-editor', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "conteudo_historico_parceria",
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "options": _vm.quillOptionsCompleto,
      "title": '<h5>Descreva o que foi feito ou que será feito, seja um contato, reunião, assinatura de instrumento etc</h5>',
      "name": "conteudo_historico_parceria"
    },
    model: {
      value: (_vm.editando.parceriaHistorico.conteudo),
      callback: function($$v) {
        _vm.$set(_vm.editando.parceriaHistorico, "conteudo", $$v)
      },
      expression: "editando.parceriaHistorico.conteudo"
    }
  }), _vm._v(" "), (_vm.errors.first('conteudo_historico_parceria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Registre algum conteúdo para histórico da parceria")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('conteudo_historico') || _vm.errors.first('tipo_historico')))) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ok(_vm.editando, 'parceriaHistorico', _vm.editando.parceria.historicos)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.cancela(_vm.editando, 'parceriaHistorico')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.has(_vm.editando, 'parceria') && _vm._.keys(_vm.editando).length === 1),
      expression: "_.has(editando, 'parceria') && _.keys(editando).length === 1"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [(!_vm.ehVisualizacao && (!(_vm.errors.first('nome_parceria') || _vm.errors.first('parceria_situacao')))) ? _c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ok(_vm.editando, 'parceria', _vm.parceiro.parcerias)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.cancela(_vm.editando, 'parceria')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])]) : _vm._e()]) : _c('div', {
    staticClass: "text-danger"
  }, [_vm._v("\n                Crie o parceiro para poder cadastrar demais dados\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando municípios...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando abrangência...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', [_vm._v("Parceiro")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Contatos com a Instituição")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Nenhum contato adicionado ainda!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico do parceiro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nenhum histórico adicionado ainda!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dependência BB de relacionamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Dependência BB")]), _vm._v(" "), _c('th', [_vm._v("Contato")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("E-mail")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando dependências BB...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Parcerias / Ações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Nenhuma parceria ainda!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando abrangência...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" Parceiro")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Instrumentos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nenhum instrumento adicionado ainda!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde Instrumentos")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Fundação BB")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Parceiros")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', [_vm._v("Fundação BB")]), _vm._v(" "), _c('th', [_vm._v("Parceiro")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Projetos da parceria")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nenhum projeto foi informado ainda!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde Projetos")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Fundação BB")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Parceiros")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Enquadramento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico da parceria")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nenhum histórico adicionado ainda!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bcc0e78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/articulacao/EditaArticulacao.vue
// module id = 1942
// module chunks = 1